export const OnAdvisorChange = (name: string, setSavingsAgreementAdvisorName?: (name: string) => void) => {
  setSavingsAgreementAdvisorName?.(name);
};

export const OnMonthlyAmountChange = (amount: string, setMonthlyAmount?: (value: number) => void) => {
  const monthlyAmount = Number(amount);
  setMonthlyAmount?.(monthlyAmount);
};

export const OnSavingsNameChange = (name: string, setSavingsAgreementName?: (name: string) => void) => {
  setSavingsAgreementName?.(name);
};

export const OnStartAmountChange = (
  amount: string,
  setOneTimeDeposit?: (value: number) => void,
  setAgreementOneTimeDeposit?: (value: number) => void,
) => {
  const oneTimeDeposit = Number(amount);
  setOneTimeDeposit?.(oneTimeDeposit);
  setAgreementOneTimeDeposit?.(oneTimeDeposit);
};

export const OnNumMonthsChange = (id: number, setNumOfMonthsStartupAmount?: (value: number) => void) => {
  const numMonths = GetNumMonths(id);
  setNumOfMonthsStartupAmount?.(numMonths);
};

function GetNumMonths(index: number) {
  if (index === 0) return 1;
  if (index === 1) return 3;
  if (index === 2) return 6;
  if (index === 3) return 12;
  return 0;
}

export const OnPeriodDayChange = (id: number, setSavingsAgreementPeriodDayNumber?: (periodDayNumber: number) => void) => {
  const periodDayNumber = GetPeriodDayNumber(id);
  setSavingsAgreementPeriodDayNumber?.(periodDayNumber);
};

function GetPeriodDayNumber(index: number) {
  if (index === 0) return 1;
  if (index === 1) return 10;
  if (index === 2) return 15;
  if (index === 3) return 25;
  return 0;
}
